import React from 'react';
import { Link } from 'react-router-dom';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import IconButton from '@material-ui/core/IconButton';

const styles = {
  position: {
    position: 'fixed',
    left: '25px',
    top: '85px'
  },
  icon: {
    height: '2em',
    width: '2em'
  }
};

const NavigateIcon = props => (
  <Link style={styles.position} to={props.to} id={props.id}>
    <IconButton>
      <NavigateBefore style={styles.icon} />
    </IconButton>
  </Link>
);

export default NavigateIcon;
